import { ReactComponent as FolderIcon } from '../img/folder.svg';
import { FC } from 'react';
import styles from './FilePreviewInfo.module.scss';

interface FilePreviewInfoProps {
  fileName: string;
}

export const FilePreviewInfo: FC<FilePreviewInfoProps> = ({ fileName }) => {
  return (
    <div className={styles.fileInfo}>
      <FolderIcon />
      <div className={styles.fileDetails}>
        <span className={styles.fileName}>{fileName}</span>
        <span className={styles.fileDate}>{new Date().toLocaleDateString('ru-RU')}</span>
      </div>
    </div>
  );
};
